import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import TabTable from '../../../components/tables/TabTable';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import ClaimDisposition from 'src/components/ClaimDisposition';
import { TABLE_CLAIMS_PER_PAGE } from './constants';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

const useStyles = makeStyles(() => ({
  Open: {
    marginRight: -2,
    color: '#007913',
    backgroundColor: '#D4F9DC',

    '&:hover': {
      backgroundColor: '#D4F9DC',
    }
  },
  Closed: {
    marginRight: -2,
    color: '#006791',
    backgroundColor: '#D4EEF9',

    '&:hover': {
      backgroundColor: '#D4EEF9',
    }
  },
}));

const getformattedDate = (dateString) => {
  return dateString ? format(parseISO(dateString), 'M/d/y h:mm aaa') : '';
};

export default function TableView({ claims, page, isLoading, cardClickHandler }) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const claimsPerPage = TABLE_CLAIMS_PER_PAGE;
  const claimsTableSettings = {
    isLoading,
    tableData: claims,
    idKey: 'key',
    cursorOnRowHover: true,
    paginationState: [
      {
        limit: claimsPerPage,
        page
      },
      () => { }
    ],
    onClickRow: claim => {
      if (cardClickHandler) {
        cardClickHandler(claim);
        return;
      }
      history.push({
        pathname: '/glass/browse-claim',
        search: `?claimId=${claim.claimId}`,
      });
    },
    // Table headers
    tableHeadDisplay: () => [
      {
        key: 'lastUpdated',
        text: t('lastUpdated'),
        width: '25%'
      },
      {
        key: 'name',
        text: t('claimant'),
        width: '20%'
      },
      {
        key: 'dealer',
        text: t('glassClaim.dealerName'),
        width: '20%'
      },
      {
        key: 'shipperNumber',
        text: t('glassClaim.order.shipperNumber'),
        width: '20%'
      },
      {
        key: 'orderNumber',
        text: t('glassClaim.order.orderNumber'),
        width: '20%'
      },
      {
        key: 'OMC',
        text: t('glassClaim.order.omcNumber'),
        width: '20%'
      },
      {
        key: 'claimNumber',
        text: t('claimNumber'),
        width: '20%'
      },

      {
        key: 'causeOfLoss',
        text: t('reason'),
        width: '30%'
      },
      {
        key: 'status',
        text: t('status'),
        width: '10%'
      },
      {
        key: 'disposition',
        text: t('disposition'),
        width: '30%'
      },
      {
        key: 'documentCount',
        text: t('attachmentCount'),
        width: '5%'
      },
    ],
    tableRowDisplay: claim => [
      getformattedDate(claim.lastUpdateDate),
      claim.claimantName,
      claim.dealerName,
      claim.trackingNumber,
      claim.vendorPurchaseOrder,
      claim.orderMasterControlNumber,
      claim.claimId,
      claim.disablementDescription,
      <Chip
        clickable
        key={claim.claimId}
        className={classes[claim.claimStatus]}
        label={claim.claimStatus}
      />,
      <ClaimDisposition
        key={claim.claimId}
        disposition={claim.claimDisposition}
        textVariant="body2"
        hasLabel={false}
      />,
      claim.documentCount
    ]
  };

  return (
    <TabTable {...claimsTableSettings} />
  )
}

TableView.propTypes = {
  claims: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      claimStatus: PropTypes.string,
      currentDisposition: PropTypes.string,
      lastUpdateDate: PropTypes.string,
      reviewer: PropTypes.number,
      claimantName: PropTypes.string,
      claimId: PropTypes.number,
      amountRequested: PropTypes.number,
      claimType: PropTypes.string,
      coverageName: PropTypes.string,
      policyNumber: PropTypes.string,
      policyMember: PropTypes.string,
      vin: PropTypes.string
    })
  ).isRequired,
  page: PropTypes.number,
  isLoading: PropTypes.bool,
  cardClickHandler: PropTypes.func
};
